import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';

const getTravelDocumentQuery = graphql(/* GraphQL */ `
  query travelDocumentUserId($userId: String!) {
    travelDocumentUserId(userId: $userId) {
      documentId
      userId
      countryOfIssuance
      expiryDate
      passportNumber
    }
  }
`);

const useGetTravelDocument = (userId: string, enabled: boolean = false) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    travelDocumentUserId: {
      documentId: number;
      userId: string;
      countryOfIssuance: string;
      expiryDate: string;
      passportNumber: string;
    } | null;
  }>({
    queryKey: ['travelDocument', userId],
    queryFn: async () =>
      graphqlRequest(
        getTravelDocumentQuery,
        { userId },
        enabled && isAuthenticated ? getAccessTokenSilently : undefined,
      ),
    enabled: enabled && isAuthenticated,
    retry: shouldRetryQuery,
  });

  const travelDocument = data?.travelDocumentUserId;

  return {
    travelDocument,
    isLoading,
    isError: !!error,
    error,
    refetch,
    isFetching,
  };
};

export default useGetTravelDocument;
